import { defineMessages } from "react-intl";

import { node as childPughClassification } from "src/modules/ltx/forms/phase-i/medical-history/childPughClassification";
import { node as allergiesAndSensitivities } from "src/modules/ltx/forms/phase-i/medical-history/allergiesAndSensitivities";
import { node as comorbidities } from "src/modules/ltx/forms/phase-i/medical-history/comorbidities";
import { node as indicationForLiverTransplantation } from "src/modules/ltx/forms/phase-i/medical-history/indicationForLiverTransplantation";
import { node as liverRelatedComplications } from "src/modules/ltx/forms/phase-i/medical-history/liver-related-complications";
import { node as medicalTreatment } from "src/modules/ltx/forms/phase-i/medical-history/medicalTreatment";
import { node as pregnanciesAndChildren } from "src/modules/ltx/forms/phase-i/medical-history/pregnanciesAndChildren";
import { node as summaryReport } from "src/modules/ltx/forms/phase-i/medical-history/summaryReport";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.medical_history",
		defaultMessage: "Anamnézis"
	}
});

export const node: ParentNode = {
	id: "medicalHistory",
	value: { type: "wizard", title: messages.title },
	children: [
		childPughClassification,
		indicationForLiverTransplantation,
		liverRelatedComplications,
		comorbidities,
		pregnanciesAndChildren,
		allergiesAndSensitivities,
		summaryReport,
		medicalTreatment
	]
};
